export const getProgramEnrollmentByCidDefault = '{\n' +
    '    "programName": ""\n' +
    '    "profileId": ""\n' +
    '}';

export interface IGetProgramEnrollmentByCidRequest {
    programName: string
    profileId: string
}
